import { Route, Routes } from 'react-router';
import { BrowserRouter } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import { Configuracao } from './paginas/Configuracao';
import { Sorteio } from './paginas/Sorteio';


function App() {
  return (
    <BrowserRouter>
      <RecoilRoot>
        <Routes>
          <Route path='/'
            element={
              <Configuracao/>
            } />
          <Route path='/sorteio'
            element={<Sorteio/>} />
        </Routes>
      </RecoilRoot>

    </BrowserRouter>
  );
}

export default App;
